
export class DynamicLoader{
    /**
     * 
     * @param urls url Array
     */
    constructor(urls){
        
        this.urls = urls;
    }
    // ==========
    // private 
    // ----------
    getUrls(){ return this.urls }

    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement
    createScriptTag(url, onload, onerror){
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = onload; 
        script.onerror = onerror;
        return script;
    }

    loadError(url){
        return (error)=>{
            console.log(`error loading script ${url}: ${error}`)
            return;
        }
    }

    loadSuccess(url){
        return ()=>{
            console.log(`successfully loading script ${url}`);
            return;
        }
    }

    createLinkTag(url, onload, onerror){
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = url;
        link.onload = onload;
        link.onerror = onerror;
        return link;
    }

    appendTag(tag){
        document.head.appendChild(tag);
    }

    initLoading(url, onload, onerror){  
        var fileExtension = this.getFileExtension(url);
        var tag; 
        switch(fileExtension){
            case 'js' :
                tag = this.createScriptTag(url, onload, onerror);
                break;
            case 'css':
                tag = this.createLinkTag(url, onload, onerror);
                break; 
            default:
               tag = this.createScriptTag(url, onload, onerror);
        }
        this.appendTag(tag);
    }



    getFileExtension(url){
        var arr = url.split('?')[0].split('/');
        var extension = arr[arr.length-1].split('.')[1];
        return extension;
    }

    loadUrl(url){
        var promise = new Promise((resolve,reject)=>{
            this.initLoading(url,resolve,reject)
            return;
        })
        .then(this.loadSuccess(url))
        .catch(this.loadError(url))
        return promise;
    }


    // ===========
    // public (API)
    // -----------
    loadAll(){
        var promises = this.getUrls().map(url => this.loadUrl(url))
        return Promise.all(promises);
    }

}